import { Badge } from "@/components/ui/badge"
import { CLIP_STATUS_LABELS, type ClipStatus } from "./types"

const STATUS_TONE: Record<ClipStatus, "neutral" | "accent" | "signal" | "muted" | "solid"> = {
  enriched:              "accent",
  queued_for_enrichment: "signal",
  needs_processing:      "neutral",
  deprecated:            "muted",
  missing:               "solid",
}

export function ClipStatusBadge({ status }: { status: ClipStatus }) {
  return <Badge tone={STATUS_TONE[status]}>{CLIP_STATUS_LABELS[status]}</Badge>
}
